import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

import { ProjectStatusLabelType } from 'domains/projects/const';

const getBackgroundColor = (type: ProjectStatusLabelType, theme: Theme) => {
  switch (type) {
    case ProjectStatusLabelType.Active:
      return theme.palette.surface.successLight;
    case ProjectStatusLabelType.Frozen:
      return theme.palette.surface.purpleLight;
    case ProjectStatusLabelType.Suspended:
      return theme.palette.surface.errorLight;
    case ProjectStatusLabelType.Draft:
      return theme.palette.surface.primary;
    default:
      return theme.palette.grey[600];
  }
};

const getTextColor = (type: ProjectStatusLabelType, theme: Theme) => {
  switch (type) {
    case ProjectStatusLabelType.Active:
      return theme.palette.surface.success;
    case ProjectStatusLabelType.Frozen:
      return theme.palette.surface.purple;
    case ProjectStatusLabelType.Suspended:
      return theme.palette.surface.error;
    case ProjectStatusLabelType.Draft:
      return theme.palette.text.secondary;
    default:
      return theme.palette.text.primary;
  }
};

export const useProjectStatusLabelStyles = makeStyles<ProjectStatusLabelType>()(
  (theme, type) => ({
    projectStatusLabel: {
      fontWeight: 500,
      color: getTextColor(type, theme),
      padding: theme.spacing(0.6, 1.2),
      backgroundColor: getBackgroundColor(type, theme),
      borderRadius: theme.shape.borderRadiusSm,
      whiteSpace: 'nowrap',
    },
    divider: {
      color: theme.palette.text.disabled,
      marginLeft: theme.spacing(-3),
      marginRight: theme.spacing(-2),
    },
  }),
);
